import { HttpErrorResponse } from '@angular/common/http';

export function getHttpErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof HttpErrorResponse) {
    const apiMessage = err.error?.message;
    if (typeof apiMessage === 'string' && apiMessage.trim().length > 0) {
      return apiMessage;
    }
    if (typeof err.error?.statusCode === 'number') {
      return `Erreur ${err.error.statusCode}`;
    }
    if (typeof err.message === 'string' && err.message.trim().length > 0) {
      return err.message;
    }
  }

  if (err instanceof Error && err.message.trim().length > 0) {
    return err.message;
  }

  return fallback;
}
